module.exports = Tesseract;


//////////////////
// WEBPACK FOOTER
// external "Tesseract"
// module id = 927
// module chunks = 